import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentService } from 'src/app/services/document.service';
import { FolderNode } from 'src/app/shared/interfaces/IDocument';

@Component({
  standalone: true,
  selector: 'app-document-folder-tree-node',
  templateUrl: './document-folder-tree-node.component.html',
  styleUrl: './document-folder-tree-node.component.scss',
  imports: [DocumentFolderTreeNodeComponent]
})
export class DocumentFolderTreeNodeComponent {
  @Input({ required: true }) node!: FolderNode;
  @Input() selectedNode: FolderNode | null = null;
  @Output() nodeSelected = new EventEmitter<FolderNode>();

  constructor(private documentService: DocumentService) {}

  toggle(event: Event) {
    event.stopPropagation();
    this.node.expanded = !this.node.expanded;
    if (this.node.expanded && !this.node.childrenLoaded) {
      this.loadChildren();
    }
  }

  select() {
    this.nodeSelected.emit(this.node);
  }

  onChildSelected(node: FolderNode) {
    this.nodeSelected.emit(node);
  }

  private loadChildren() {
    this.node.loading = true;
    this.documentService.getDocuments(this.node.path || null).subscribe({
      next: (res) => {
        this.node.children = (res.dirs ?? []).map((dir: { path: string; name: string }) => ({
          path: dir.path,
          name: dir.name,
          children: [],
          childrenLoaded: false,
          loading: false,
          expanded: false
        }));
        this.node.childrenLoaded = true;
        this.node.loading = false;
      },
      error: () => {
        this.node.childrenLoaded = true;
        this.node.loading = false;
      }
    });
  }
}
